import { gql } from '@apollo/client';

export const GET_POST_IMAGE = gql`
  query post($author: String!, $permlink: String!) {
    post(author: $author, permlink: $permlink) {
      thumbnail
    }
  }
`;

export const GET_VOTES_SMILES = gql`
  query post($author: String!, $permlink: String!) {
    post(author: $author, permlink: $permlink) {
      comments
      totalSmiles
      smiles {
        voter
        value
      }
    }
  }
`;

export const GET_POST_BODY = gql`
  query post($author: String!, $permlink: String!) {
    post(author: $author, permlink: $permlink) {
      body
    }
  }
`;

export const GET_POST_BY_ID = gql`
  query postById($id: String!) {
    postById(id: $id) {
      author {
        username
      }
      permlink
      title
    }
  }
`;

export const GET_BLOG_POST = gql`
  query blogPost($permlink: String!) {
    blogPost(permlink: $permlink) {
      _id
      createdAt
      excerpt
      author {
        username
        displayName
        avatar
        roles
      }
      permlink
      title
      body
      comments
      totalSmiles
      cover {
        url
        blur
      }
      thumb {
        url
        blur
      }
      youtubeId
      updatedAt
      smiles {
        voter
        value
      }
      tags
      wordCount
      readTime
      channelId
      seo {
        metaDescription
        isIndex
        twitter {
          description
          title
          thumbnail
        }
        facebook {
          description
          title
          thumbnail
        }
      }
      images {
        url
        width
        height
        blur
      }
      faq {
        questionName
        acceptedAnswerText
      }
    }
  }
`;

export const GET_POST = gql`
  query post($author: String!, $permlink: String!) {
    post(author: $author, permlink: $permlink) {
      _id
      createdAt
      excerpt
      author {
        username
        displayName
        avatar
        roles
      }
      permlink
      title
      location {
        countryCode
        subdivision
        city
        coordinates {
          coordinates
        }
        bbox
      }
      body
      comments
      totalSmiles
      cover {
        url
        blur
      }
      thumb {
        url
        blur
      }
      youtubeId
      updatedAt
      smiles {
        voter
        value
      }
      tags
      wordCount
      readTime
      community {
        id
        title
        lang
      }
      blacklist {
        isUnlisted
        isMembersOnly
        isNoindex
      }
      channelId
      seo {
        metaDescription
        canonicalUrl
        hostingUrl
        isIndex
        twitter {
          description
          title
          thumbnail
        }
        facebook {
          description
          title
          thumbnail
        }
      }
      app
      images {
        url
        width
        height
        blur
      }
      truvvl {
        bgLayer {
          bgColor
          img
        }
        contentLayer {
          text {
            value
            color
            textAlign
            top
            bgColor
            fontSize
          }
        }
        dataLayer {
          location {
            lat
            lng
          }
        }
      }
      faq {
        questionName
        acceptedAnswerText
      }
      isBlog
      isUgcLinks
    }
  }
`;

export const GET_POST_ID = gql`
  query post($author: String!, $permlink: String!) {
    post(author: $author, permlink: $permlink) {
      _id
    }
  }
`;

export const GET_POST_EDIT = gql`
  query privatePost($permlink: String!) {
    privatePost(permlink: $permlink) {
      _id
      createdAt
      excerpt
      author {
        username
        displayName
        avatar
        roles
      }
      permlink
      title
      location {
        countryCode
        subdivision
        city
        coordinates {
          coordinates
        }
      }
      body
      comments
      totalSmiles
      thumbnail
      coverImage
      youtubeId
      updatedAt
      smiles {
        voter
        value
      }
      tags
      wordCount
      readTime
      community {
        id
        title
        lang
      }
      blacklist {
        isBlacklistedFromPost
        isUnlisted
        isMembersOnly
      }
      postOptions {
        easyEditorId
        focusKeyphrase
        steem {
          enabled
          onlyExcerpt
        }
        hive {
          enabled
          topLink
          onlyExcerpt
          blog
          payoutType
          community
          beneficiaries {
            account
            weight
          }
        }
      }
      seo {
        metaDescription
        canonicalUrl
        isIndex
        twitter {
          description
          title
          thumbnail
        }
        facebook {
          description
          title
          thumbnail
        }
      }
      blogs
      editor {
        isCodeEditor
        code
      }
    }
  }
`;
